(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 7264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(6968);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ contact_us_ContactUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
;// CONCATENATED MODULE: ./src/page-components/contact-us/ContactUs.tsx



var ContactUs = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* MainLayout */.Zn, {
        noPaddingTop: true,
        footerTheme: "light",
        footerSticky: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Contact Us | Chacra Software Solutions"
            })
        })
    });
};
/* harmony default export */ var contact_us_ContactUs = (ContactUs);

;// CONCATENATED MODULE: ./src/page-components/contact-us/index.ts


;// CONCATENATED MODULE: ./src/pages/contact-us.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,13,234,5,25,774,888,179], function() { return __webpack_exec__(7264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);